import type { HyperlinkedMediaProps } from 'libs/contentful/types';
import { toMediaAsset } from 'components/shared/Media/toMediaAsset';
import type { RawHyperlinkedMedia } from './types';

export function toHyperlinkedMedia(entry: RawHyperlinkedMedia): HyperlinkedMediaProps | undefined {
  if (!entry || !('fields' in entry)) {
    return undefined;
  }

  const image = entry.fields.image && toMediaAsset(entry.fields.image);
  return image ? { link: entry.fields.link, image } : undefined;
}
